exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read_only[data-v-86cef5e6]{border-color:#f7f7f7!important;color:#262626!important}.accordion .read_only[data-v-86cef5e6],.read_only[data-v-86cef5e6]{background-color:#f7f7f7!important}.accordion .read_only[data-v-86cef5e6]{border-color:#d8d8d8!important;color:#464646!important}.read_only[data-v-86cef5e6]::-moz-placeholder{color:transparent!important}.read_only[data-v-86cef5e6]::placeholder{color:transparent!important}", ""]);

// exports
